// extracted by mini-css-extract-plugin
export var currentStep = "_gh-2";
export var nodeCard = "_gh-0";
export var pathHighlighted = "_gh-1";